import { memo, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isCommonMessageFormat, isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getFromAddress, getFromName, getIsMemberOfForwardedSubthread, getIsForward, getTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { getCommonMessageSenderId } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderId';
// @ts-expect-error module not typed
import { getCommonMessageSenderType } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderType';
// @ts-expect-error module not typed
import { getSenderIdOrVid } from 'conversations-message-history/common-message-format/operators/getSenderIdOrVid';
import { getMessageDirection, getGenericChannelId, getSingleRecipientTypeFromMessage, getSingleRecipientIdFromMessage, getAttachments, getRecipients, getSenders, getSenderDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { List as ImmutableList, Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
// @ts-expect-error module not typed
import { getCallMetadataAttachment } from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
import { AGENT as DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import { CALLING_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { findLegacyRecipient } from 'conversations-message-history/legacy-recipients/operators/findLegacyRecipient';
import { getFirstName, getLastName, getSenderType } from 'conversations-message-history/senders/operators/getters';
import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { isRecipientLoading } from 'conversations-message-history/legacy-recipients/operators/isRecipientLoading';
// @ts-expect-error module not typed
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import Sender from 'conversations-message-history/senders/records/Sender';
import { CallInfoHeader } from '../common-message-header/CallInfoHeader';
import getMessageIdFromLocation from './operators/getMessageIdFromLocation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import DeliveryStatusFooter from '../delivery-status/DeliveryStatusFooter';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import { CallStatusMessage } from '../call-status/CallStatusMessage';
import { ForwardSubject } from './ForwardSubject';
import { useContainerQuery } from '../util/useContainerQuery';
import RecipientLine from './RecipientLine';
import { getMessageRecipientNames } from './operators/getMessageRecipientNames';
import FullSenderName from '../senders/components/FullSenderName';
import { isSenderPresent } from 'conversations-message-history/senders/operators/isSenderPresent';
import { getTotalRecipientsCount } from '../common-message/operators/getTotalRecipientsCount';
import { getEmailMetadata } from 'conversations-message-history/common-message-format/operators/getEmailMetadata';
import CommonMessageHeaderPopover from '../common-message-popover/CommonMessageHeaderPopover';
import CommonMessageSection from './CommonMessageSection';
import CommonMessageAttachmentsFooter from './CommonMessageAttachmentsFooter';
import SlottedMessage from '../slotted-message/SlottedMessage';
import { ChannelIcon } from '../atoms/ChannelIcon';
import SenderAvatar from '../avatar/SenderAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACTIONS_COLLAPSE_WIDTH = 600;
export const ICON_MINIMIZE_WIDTH = 500;
const CommonMessageDetail = ({
  totalRecipients,
  isForwarded
}) => {
  if (isForwarded && totalRecipients) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "email-header-forwarded-recipient-count",
      message: "conversations-inbox-message-history.email.messageHeaderForwardedRecipientsCount",
      options: {
        count: totalRecipients
      }
    });
  } else if (totalRecipients > 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "email-header-recipient-count",
      message: "conversations-inbox-message-history.email.messageHeaderRecipientsCount",
      options: {
        count: totalRecipients
      }
    });
  }
};
CommonMessageDetail.displayName = 'CommonMessageDetail';
const CommonMessage = props => {
  const {
    message,
    positionDescriptors,
    highlight,
    fileAttachments,
    friendlyNames,
    onClickAvatar,
    presentSenderLocators,
    senders,
    vid,
    senderName,
    legacyRecipients,
    channelName,
    messageActions,
    visitorLastReadTimestamp,
    messageContainerRef
  } = props;
  const [breakpointResults] = useContainerQuery([ICON_MINIMIZE_WIDTH], messageContainerRef);
  const [clearDeepLinkHighlight, setClearDeepLinkHighlight] = useState(false);
  const iconShouldMinimize = breakpointResults[ICON_MINIMIZE_WIDTH];
  const location = useLocation();
  const deepLinkedMessageId = getMessageIdFromLocation(location);
  const isMessageDeepLinked = deepLinkedMessageId === message.id;
  const shouldHighlightDeepLinkedMessage = isMessageDeepLinked && !clearDeepLinkHighlight;
  const shouldHighlight = highlight || shouldHighlightDeepLinkedMessage;

  // TODO: improve a11y by making the container focusable, see this issue: https://git.hubteam.com/HubSpot/conversations-inbox-message-history/issues/1884
  useEffect(() => {
    const onClickRemoveHighlight = () => setClearDeepLinkHighlight(true);
    if (isMessageDeepLinked) {
      // timeout is needed to ensure the click event is not immediately triggered
      setTimeout(() => window.addEventListener('click', onClickRemoveHighlight, {
        once: true
      }));
    }
    return () => window.removeEventListener('click', onClickRemoveHighlight);
  }, [isMessageDeepLinked]);

  // TODO: clean up inbound call received message code once BE refactors call status messages
  const genericChannelId = getGenericChannelId(message);
  const messageDirection = getMessageDirection(message);
  const attachments = getAttachments(message);
  const senderRecord = getSenders(message).first();
  const senderEmail = getSenderDeliveryIdentifierValue(senderRecord);
  // the welcome message will always be from the sample contact Maria Johnson with email 'emailmaria@hubspot.com'
  const sampleContactEmail = 'emailmaria@hubspot.com';
  const isInboundCallReceivedMessage = genericChannelId === CALLING_GENERIC_CHANNEL_ID && messageDirection === INCOMING && attachments.size === 0 && senderEmail !== sampleContactEmail;
  const isFwdItself = isEmailCMF(message) && getIsForward(message);
  const genericSenders = getSenders(message);
  const senderId = getCommonMessageSenderId({
    message
  });
  const senderType = getCommonMessageSenderType({
    message
  });
  const updatedSenderId = getSenderIdOrVid({
    message,
    vid,
    senderId
  });
  const asyncSender = findSender(updatedSenderId, senderType, senders);
  const present = isSenderPresent(updatedSenderId, senderType, presentSenderLocators);
  const senderLoading = isSenderLoading(asyncSender);
  let sender = getData(asyncSender);
  if (!sender || senderEmailDoesNotMatchVisitor({
    sender,
    message
  }) ||
  // If sender object for the visitor exists but first name and last name does not exists then use
  // from address for displaying name in email header
  getFromAddress(message) && !getFirstName(sender) && !getLastName(sender)) {
    sender = Sender({
      senderType,
      firstName: getFromName(message),
      email: getFromAddress(message) || null
    });
  }
  const genericRecipients = getRecipients(message);
  const recipientId = getSingleRecipientIdFromMessage(message);
  const recipientType = getSingleRecipientTypeFromMessage(message);
  const asyncRecipient = recipientId && recipientType && legacyRecipients && findLegacyRecipient(recipientId, recipientType, legacyRecipients);
  const recipient = getData(asyncRecipient) || undefined;
  const recipientLoading = isRecipientLoading(asyncRecipient);
  const isForwarded = isEmailCMF(props.message) && getIsMemberOfForwardedSubthread(props.message);
  const isEmailMessage = isCommonMessageFormat(message) && Boolean(getEmailMetadata(message));
  const totalRecipients = isEmailMessage ? getTotalRecipientsCount({
    message: message
  }) : 0;
  const isFromVisitor = senderType === VISITOR_SENDER;
  // TODO: why is the following used to check visitor status? Should use only one of these two.
  const isVisitor = getSenderType(senderRecord) === VISITOR;
  const isCalling = isCommonMessageFormat(message) && Boolean(getCallMetadataAttachment(message));
  const messageTimestamp = getTimestamp(message);

  // Slot display bools:
  const shouldDisplayByline = isEmailCMF(message);
  const shouldDisplayAnnotation = !(getCallMetadataAttachment(message) || senderType === VISITOR_SENDER);
  return isInboundCallReceivedMessage ? /*#__PURE__*/_jsx(CallStatusMessage, {
    message: message
  }) // Need to deal with this -- this is a system message
  : /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        'data-test-id': `primary-message-${isFromVisitor ? VISITOR : DEFAULT}`,
        'data-debug-common-message-mismatch': true,
        positionDescriptors,
        use: DEFAULT,
        ref: messageContainerRef,
        highlight: shouldHighlight
      }
    },
    avatar: {
      isLoading: senderLoading,
      Component: SenderAvatar,
      componentProps: {
        onClick: onClickAvatar,
        sender,
        present,
        size: 'sm'
      }
    },
    indicator: {
      renderCustom: ({
        Component
      }) => {
        if (isFromVisitor || isForwarded) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Component, {
              forwarded: isForwarded,
              "data-test-id": `${isFromVisitor ? 'visitor' : 'forwarded'}-indicator-bar`
            }), isFwdItself ? /*#__PURE__*/_jsx(ForwardSubject, {
              message: message
            }) : null]
          });
        } else if (isFwdItself) {
          return /*#__PURE__*/_jsx(ForwardSubject, {
            message: message
          });
        }
        return null;
      }
    },
    title: {
      isLoading: senderLoading,
      loaderProps: {
        use: isVisitor ? 'on-dark' : 'default'
      },
      Component: isCalling ? CallInfoHeader : FullSenderName,
      componentProps: isCalling ? {
        message,
        recipient,
        isRecipientLoading: recipientLoading,
        sender,
        senderName,
        isSenderLoading: senderLoading,
        genericSenders,
        genericRecipients,
        'data-test-id': 'sender-name'
      } : {
        sender,
        senderName,
        genericSenders,
        'data-test-id': 'sender-name'
      }
    },
    byline: shouldDisplayByline ? {
      Component: RecipientLine,
      componentProps: {
        recipientNames: getMessageRecipientNames({
          message,
          friendlyNames
        })
      }
    } : null,
    detail: isForwarded && totalRecipients || totalRecipients > 1 ? {
      Component: CommonMessageDetail,
      componentProps: {
        totalRecipients,
        isForwarded
      }
    } : null,
    channel: {
      renderCustom: () => {
        return iconShouldMinimize ? /*#__PURE__*/_jsx(ChannelIcon, {
          genericChannelId: genericChannelId,
          channelName: channelName
        }) : channelName || /*#__PURE__*/_jsx(ChannelIcon, {
          genericChannelId: genericChannelId
        });
      }
    },
    detailsPopover: {
      Component: CommonMessageHeaderPopover,
      componentProps: {
        message,
        sender,
        isSenderLoading: senderLoading,
        recipient,
        isRecipientLoading: recipientLoading,
        isForwarded,
        genericChannelId,
        friendlyNames
      }
    },
    timestamp: {
      componentProps: {
        timestamp: messageTimestamp
      }
    },
    actions: {
      renderCustom: () => messageActions
    },
    body: {
      Component: CommonMessageSection,
      componentProps: props
    },
    footerBody: {
      Component: CommonMessageAttachmentsFooter,
      componentProps: {
        message,
        fileAttachments
      }
    },
    annotation: shouldDisplayAnnotation ? {
      Component: DeliveryStatusFooter,
      componentProps: {
        timestamp: message.timestamp,
        status: message.status,
        positionDescriptors,
        visitorLastReadTimestamp: visitorLastReadTimestamp || null
      }
    } : null
  });
};
CommonMessage.displayName = 'CommonMessage';
CommonMessage.propTypes = {
  channelName: PropTypes.string,
  directReplyState: PropTypes.any,
  // refer to the TS type instead
  fetchReplies: PropTypes.func,
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  fileAttachments: PropTypes.instanceOf(ImmutableList),
  fileAttachmentsForThread: PropTypes.any,
  // refer to the TS type instead
  friendlyNames: PropTypes.any,
  // refer to the TS type instead
  handleFetchImageProcessingStatus: PropTypes.func,
  hiddenBy: PropTypes.shape({
    actorId: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired
  }),
  hiddenMessage: PropTypes.node,
  highlight: PropTypes.bool,
  indexedAsyncFileAttachments: PropTypes.any,
  // refer to the TS type instead
  lastMessageId: PropTypes.string,
  legacyRecipients: PropTypes.any,
  // refer to the TS type instead
  message: RecordPropType('CommonMessage').isRequired,
  messageActions: PropTypes.node,
  messageContainerRef: PropTypes.any,
  // refer to the TS type instead
  messageReplyIsLoading: PropTypes.bool,
  numberOfProcessingImages: PropTypes.number,
  onClickAvatar: PropTypes.func,
  onClickToForward: PropTypes.func,
  onClickToReply: PropTypes.func,
  onClickToReplyAll: PropTypes.func,
  plainTextMode: PropTypes.bool.isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  presentSenderLocators: PropTypes.instanceOf(ImmutableSet).isRequired,
  senderName: PropTypes.node,
  senders: SenderMap,
  shouldDisplayBanner: PropTypes.bool,
  threadId: PropTypes.any,
  // refer to the TS type instead
  ungatedForAutogenerateCopilotCallSummary: PropTypes.bool,
  ungatedForChatspot: PropTypes.bool,
  ungatedForCopilotPreview: PropTypes.bool,
  ungatedForNextBestActions: PropTypes.bool,
  vid: PropTypes.number,
  visitorLastReadTimestamp: PropTypes.number
};
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
CommonMessage.defaultProps = {
  plainTextMode: false,
  presentSenderLocators: ImmutableSet()
};
export default /*#__PURE__*/memo(CommonMessage);